export default __webpack_public_path__ + "media/images/react_icons/map-grey-16fa9f82d594db5751b5a2735f358e8f.svg";